import { render } from "./ResultRaceBlock.vue?vue&type=template&id=0d6e4d77&scoped=true"
import script from "./ResultRaceBlock.vue?vue&type=script&lang=js"
export * from "./ResultRaceBlock.vue?vue&type=script&lang=js"

import "./ResultRaceBlock.vue?vue&type=style&index=0&id=0d6e4d77&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6e4d77"]])

export default __exports__